import { createMuiTheme } from '@material-ui/core';
import { GLOBAL_FONT_THEME } from '../../../theme/CommonTheme';

export const MUIDATATABLE_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MUIDataTableToolbar: {
            root: {
                backgroundColor: '#fff',
                padding: 8,
                paddingRight: '8px !important'
            },
            actions: {
                paddingRight: 20
            }
        },

        MUIDataTableToolbarSelect: {
            title: {
                fontWeight: 500,
                fontSize: '21px'
            }
        },

        MUIDataTable: {
            responsiveBase: {
                maxHeight: 'calc(100vh - 200px)',
                minHeight: 'calc(100vh - 200px)',
                backgroundColor: '#fafafa'
            }
        },
        MUIDataTableHeadCell: {
            data: {
                color: '000000de',
                fontSize: '14px',
                fontFamily: "'Open Sans', sans-serif",
                fontWeight: 600
            },
            toolButton: {
                height: '20px'
            },
            sortAction: {
                paddingTop: 4,
                fontSize: 14,
                fontFamily: "'Open Sans', sans-serif",
                fontWeight: 600
            }
        },
        MUIDataTableSelectCell: {
            root: {
                width: 1
            },
            icon: {
                color: '#005F9E'
            },
            expanded: {
                transition: 'all 500ms ease-in;'
            },
            checkboxRoot: {
                '&$checked': {
                    color: '#000000'
                }
            }
        },

        MuiTableCell: {
            head: {
                color: '000000de',
                fontSize: '0.85rem',
                fontWeight: 600,
                borderBottom: '1px solid #AEAEB6'
            },
            root: {
                paddingLeft: 10,
                borderBottom: '1px solid #e0e0e0'
            }
        },
        MuiPaper: {
            elevation4: {
                boxShadow: 'unset'
            },
            elevation2: {
                boxShadow: 'unset'
            },
            elevation1: {
                boxShadow: 'unset'
            },
            root: {
                //minHeight: 500
            }
        },
        MuiTablePagination: {
            select: {
                paddingRight: 20,
                paddingTop: 9,
                paddingLeft: 0,
                textAlign: 'left',
                textAlignLast: 'left'
            },
            selectIcon: {
                top: 0,
                height: '1.35em !important'
            }
        },
        MuiTableSortLabel: {
            icon: {
                fontSize: '1rem',
                marginTop: 12
            }
        },
        MuiSelect: {
            select: {
                minWidth: 20
            },
            icon: {
                height: '1em !important'
            }
        },
        MuiSvgIcon: {
            root: {
                width: '1em !important',
                height: '1em !important',
                fontSize: '1.4rem'
            }
        },
        MuiInputBase: {
            root: {
                color: 'rgba(0, 0, 0, 0.87) !important',
                '&:disabled': {
                    color: 'rgba(0, 0, 0, 0.87) !important'
                }
            },
            input: {
                letterSpacing: -0.8
            }
        },
        MuiInput: {
            underline: {
                borderBottomStyle: 'none',
                '&:before': {
                    borderBottom: 'none'
                },
                '&$disabled': {
                    '&:before': {
                        borderBottomStyle: 'none'
                    }
                }
            }
        },
        MuiTypography: {
            body1: {
                fontFamily: "'Open Sans SemiBold', sans-serif !important"
            },
            subtitle1: {
                fontSize: 15
            }
        },
        MuiChip: {
            label: {
                fontWeight: 600
            }
        },
        MuiTable: {
            root: {
                backgroundColor: '#fff'
            }
        },
        MuiCheckbox: {
            root: {
                '&.Mui-checked': {
                    color: '#0091ea !important'
                }
            }
        },
        MuiTableRow: {
            head: {
                borderTop: '1px solid #AEAEB6'
            }
        }
    }
});

export const MUIDATATABLE_THEME_ALT = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MUIDataTableToolbar: {
            root: {
                backgroundColor: '#fff'
            }
        },
        MuiTypography: {
            subtitle1: {
                fontSize: 15
            }
        },
        MuiPaper: {
            elevation4: {
                boxShadow: 'unset'
            },
            elevation2: {
                boxShadow: 'unset'
            },
            elevation1: {
                boxShadow: 'unset'
            },
            root: {
                paddingTop: 40
            }
        },
        MuiTableCell: {
            head: {
                color: '000000de',
                fontSize: 15,
                fontWeight: 600,
                borderBottom: '1px solid #AEAEB6'
            },
            root: {
                borderBottom: '1px solid #e0e0e0',
                paddingLeft: 22
            }
        },
        MuiSvgIcon: {
            root: {
                fontSize: '1.4rem'
            }
        },
        MuiTableSortLabel: {
            icon: {
                fontSize: '1rem',
                marginTop: 12
            }
        },
        MuiInputBase: {
            root: {
                color: 'rgba(0, 0, 0, 0.87) !important',
                '&:disabled': {
                    color: 'rgba(0, 0, 0, 0.87) !important'
                }
            },
            input: {
                letterSpacing: -0.8
            }
        },
        MuiInput: {
            underline: {
                borderBottomStyle: 'none',
                '&:before': {
                    borderBottom: 'none'
                },
                '&$disabled': {
                    '&:before': {
                        borderBottomStyle: 'none'
                    }
                }
            }
        },
        MUIDataTable: {
            responsiveBase: {
                maxHeight: 'calc(100vh - 250px)',
                minHeight: 'calc(100vh - 250px)',
                backgroundColor: '#fafafa'
            }
        },
        MuiTable: {
            root: {
                backgroundColor: '#fff'
            }
        },
        MuiTableRow: {
            head: {
                borderTop: '1px solid #AEAEB6'
            }
        }
    }
});

export const MUIEXPANDABLEROWS_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiTableCell: {
            root: {
                borderBottom: 'unset'
            },
            body: {
                backgroundColor: '#E2E2E7'
            }
        }
    }
});

export const TITLE_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiTypography: {
            body2: {
                fontSize: '1.25rem',
                fontWeight: 700,
                marginLeft: 20,
                marginTop: 10
            }
        }
    }
});

export const BUTTON_THEME = createMuiTheme({
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 2,
                letterSpacing: '1px',
                color: '#ffffff!important',
                fontWeight: '500 !important',
                fontFamily: "'Open Sans', sans-serif",
                lineSpacing: 1,
                fontSize: '14px!important',
                backgroundColor: '#0194d3 !important',
                '&:hover': {
                    backgroundColor: '#177DB6 !important'
                },
                '&:disabled': {
                    opacity: '0.4!important',
                    backgroundColor: '#177DB6 !important',
                    color: '#FFFFFF!important'
                }
            }
        }
    }
});

export const SEARCH_BAR_DARK_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiInputBase: {
            root: {
                color: '#808080'
            }
        },
        MuiInput: {
            underline: {
                '&:hover:not($disabled):not($error):not($focused):before': {
                    borderBottomColor: '#808080',
                    height: 1
                },
                '&:before': {
                    borderBottom: '1px solid #808080'
                },
                '&:after': {
                    borderBottom: '2px solid #808080'
                }
            }
        }
    }
});

export const SEARCH_BAR_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiInputBase: {
            root: {
                color: '#fff'
            }
        },
        MuiInput: {
            underline: {
                '&:hover:not($disabled):not($error):not($focused):before': {
                    borderBottomColor: '#fff',
                    height: 1
                },
                '&:before': {
                    borderBottom: '1px solid #fff'
                },
                '&:after': {
                    borderBottom: '2px solid #fff'
                }
            }
        }
    }
});

export const DIALOG_THEME = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiButton: {
            textPrimary: {
                color: '#0194d3'
            },
            label: {
                fontWeight: 600
            }
        },
        MuiTypography: {
            h6: {
                fontWeight: 600
            }
        }
    }
});
